<!-- Pulsante di download con container per tooltip personalizzato -->
<div class="relative">
  <button
    type="button"
    [class]="isDisabled ? 'bg-gray-400 cursor-not-allowed box-border content-stretch flex gap-1 h-[47px] items-center justify-center px-3 py-2.5 relative rounded-[4px] shrink-0 transition-colors duration-200 focus:outline-2 focus:outline-offset-2 focus:outline-focus-ring' : 'bg-[#20744a] hover:bg-[#1a5d3a] box-border content-stretch flex gap-1 h-[47px] items-center justify-center px-3 py-2.5 relative rounded-[4px] shrink-0 cursor-pointer transition-colors duration-200 focus:outline-2 focus:outline-offset-2 focus:outline-focus-ring'"
    [attr.aria-label]="isDownloading ? (TRANSLATION_KEYS.downloadButton.DOWNLOAD_IN_PROGRESS | translate) : (TRANSLATION_KEYS.downloadButton.DOWNLOAD_TOOLTIP | translate)"
    [disabled]="isDisabled"
    (click)="onDownloadClick()"
    [pTooltip]="!isDownloading ? (TRANSLATION_KEYS.downloadButton.DOWNLOAD_TOOLTIP | translate) : ''"
    tooltipPosition="top"
    [showDelay]="500"
    [hideDelay]="0"
    [life]="3000"
    [appendTo]="'body'"
  >
    <div
      aria-hidden="true"
      [class]="isDisabled ? 'absolute border-2 border-gray-400 border-solid inset-0 pointer-events-none rounded-[4px]' : 'absolute border-2 border-[#20744a] border-solid inset-0 pointer-events-none rounded-[4px]'"
    ></div>
    <div class="content-stretch flex items-center justify-center relative shrink-0 size-6">
      <!-- Icona download normale -->
      <svg-icon
        *ngIf="!isDownloading"
        [src]="iconSrc"
        [class]="isDisabled ? '[&>svg]:w-6 [&>svg]:h-6 text-gray-200' : '[&>svg]:w-6 [&>svg]:h-6 text-white'"
        [svgAriaLabel]="TRANSLATION_KEYS.downloadButton.DOWNLOAD_TOOLTIP | translate"
        [attr.aria-hidden]="true"
      />
      <!-- Spinner durante il download -->
      <p-progress-spinner
        *ngIf="isDownloading"
        class="mt-1"
        [style]="{
          width: '20px',
          height: '20px'
        }"
        strokeWidth="4"
        animationDuration="2s"
        [attr.aria-hidden]="true"
      />
    </div>
  </button>

  <!-- Tooltip personalizzato per download in corso -->
  <div
    *ngIf="isDownloading"
    class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 p-4 bg-gray-900 text-white whitespace-nowrap z-50 rounded-[2px]"
  >
    {{ TRANSLATION_KEYS.downloadButton.DOWNLOAD_IN_PROGRESS | translate }}
    <!-- Triangolo centrale sotto -->
    <div class="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
      <div class="w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-gray-900"></div>
    </div>
  </div>
</div>

<!-- Toast interno per notifiche di successo -->
<ape-toast />

<!-- Modale per download lunghi - Design Figma -->
<div
  *ngIf="isModalVisible"
  class="fixed inset-0 z-[9999] flex items-center justify-center"
  [attr.aria-modal]="true"
  [attr.role]="'dialog'"
  [attr.aria-labelledby]="'download-modal-title'"
>
  <!-- Background overlay scuro -->
  <div
    class="absolute inset-0 bg-black/75"
    (click)="isDownloadCompleted ? onCloseModal() : null"
    [attr.aria-hidden]="true"
  ></div>

  <!-- Modale bianca centrata -->
  <div
    class="relative bg-white max-w-[680px] w-[680px] overflow-hidden px-[60px] py-[40px] rounded-[16px] flex flex-col gap-8 items-center"
  >
    <!-- Logo - solo durante il download -->
    <ape-logo
      *ngIf="!isDownloadCompleted"
      [clickable]="false"
      variant="header"
      class="h-[50px] w-[128px] relative shrink-0"
    />

    <!-- Icona check-circle verde - quando completa -->
    <div
      *ngIf="isDownloadCompleted"
      class="overflow-hidden relative shrink-0 w-[150px] h-[150px] flex items-center justify-center"
    >
      <svg-icon
        src="assets/icons/check-circle-no-stroke.svg"
        class="w-[150px] h-[150px] stroke-[var(--colors-status-success-background)] [&>svg>path]:stroke-[1.2]"
        [applyClass]="true"
        [attr.aria-hidden]="true"
      />
    </div>

    <!-- Illustrazione animata - durante il download -->
    <div
      *ngIf="!isDownloadCompleted"
      class="h-[280px] w-[457.293px] relative shrink-0 flex items-center justify-center"
      [attr.aria-hidden]="true"
    >
      <svg-icon
        src="assets/images/page-loader.svg"
        [svgAriaLabel]="''"
        class="w-full h-full"
        [applyClass]="true"
      />
    </div>

    <!-- Contenuto testuale -->
    <div class="content-stretch flex flex-col gap-[10px] items-center relative shrink-0 text-center w-full">
      <!-- Titolo -->
      <h2
        id="download-modal-title"
        class="font-bold leading-[40px] relative shrink-0 text-black text-[36px] w-full"
      >
        {{ isDownloadCompleted ? (TRANSLATION_KEYS.downloadButton.COMPLETED_TITLE | translate) : (TRANSLATION_KEYS.downloadButton.IN_PROGRESS_TITLE | translate) }}
      </h2>

      <!-- Sottotitolo -->
      <div
        *ngIf="!isDownloadCompleted"
        class="flex flex-col justify-center relative shrink-0 text-[16px] text-black w-full"
        [innerHTML]="TRANSLATION_KEYS.downloadButton.IN_PROGRESS_MESSAGE | translate"
      ></div>
    </div>

    <!-- Spinner - solo durante il download -->
    <ape-spinner *ngIf="!isDownloadCompleted" />

    <!-- Bottone azione -->
    <ape-button
      [variant]="'primary'"
      [aspect]="'fill'"
      [size]="'medium'"
      [label]="isDownloadCompleted ? (TRANSLATION_KEYS.downloadButton.CLOSE_BUTTON | translate) : (TRANSLATION_KEYS.downloadButton.INTERRUPT_BUTTON | translate)"
      minWidth="195px"
      (buttonClick)="isDownloadCompleted ? onCloseModal() : onInterruptDownload()"
    />
  </div>
</div>
